<template lang="pug">
  .component-wallet-add-cost
    .card
      .inner-content
        .row
          .columns
            label Amount
              input(v-model="body.amount", type='number' min="0", v-on:keypress="isNumber(event)")
              label Included vat &nbsp;
                input(type="checkbox", v-model="vat")
            .help-text {{$priceWithcurrency(recordAmount)}} included vat


          .columns
            label Tax
              select(v-model="body.tax")
                option(:value="null") Select vat
                option(v-for="vat in vats", :value="vat.percentage / 100") {{vat.description }} ({{vat.name}} {{vat.percentage}}%)
            label Reason
              input(type="text", v-model="body.reason")
        .row.column
          ActionButton(:action="submit") Add to wallet

</template>
<script type="text/babel">
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import MaggieHelper from '../../maggieHelper'
    import ActionButton from '../structure/ui/ActionButton'
    import {mapState} from "vuex";

    export default {
        name: 'WalletAddCost',
        components: {ActionButton},
        data() {
            return {
                body: {
                    amount: 0,
                    reason: null,
                    tax: null,
                },
                vat: false,
                credit: false,
            }
        },
        created() {
        },
        methods: {
            submit() {

                if (this.body.reason == null || this.body.reason == '') {
                    MaggieHelper.notification('Reason', 'Please insert a valid reason')
                    return
                }

                if (this.vat) {
                    this.body.amount = this.$priceWithoutVat(this.body.amount)
                }

                if (this.credit) {
                    this.body.amount = -this.body.amount
                }

                return KeplerBackofficeSdk.wallets.make(this.body).manualRecord(this.wallet.id, () => {
                    MaggieHelper.notification('manual-record', 'Record added successfully')
                    this.body.amount = 0
                    this.body.reason = null
                    this.$emit('costAdded')
                })

            },
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event
                var charCode = (evt.which) ? evt.which : evt.keyCode
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault()

                } else {
                    return true
                }
            }
        },
        props: ['wallet'],
        computed: {
            recordAmount() {
                if (!this.vat) {
                    return this.$priceWithVat(this.body.amount, this.body.tax)
                }

                return this.body.amount
            },
          ...mapState({
            vats: state => state.configuration.vats,
            commonCostTypes: state => state.configuration.commonCostTypes,
          }),
        }
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// WalletAddCost.vue?2e83fa56